import { DataSource, FormOption } from '@qfa/forms';
import { useGetUsersLazyQuery } from '@kinetic-ui/data-layer';
import { getNodes } from 'kineticUtils/data';
import { useCallback } from 'react';

type User = {
  firstName?: string | null;
  lastName?: string | null;
  username: string;
};

const getLabel = ({ username, firstName, lastName }: User) => {
  if (firstName || lastName) {
    return `${firstName ?? ''} ${lastName ?? ''}`;
  }
  return username;
};

export const useUsersDataSource = (): DataSource<FormOption[]> => {
  const [getUsers] = useGetUsersLazyQuery({ variables: { limit: 10_000 } });

  const load = useCallback(async () => {
    const { data } = await getUsers()!;
    if (!data) {
      return [];
    }
    const { users: queryData } = data;
    const users = getNodes(queryData);
    return users
      .filter(({ id }) => {
        return id !== null;
      })
      .map(({ id, ...user }) => {
        return {
          label: getLabel(user),
          value: id,
        };
      });
  }, [getUsers]);

  return {
    load,
  };
};
